export enum EPopupStatus {
    ENABLED = "enabled",
    DISABLED = "disabled",
}